import { MediaQuestionConfig } from '@gripp/shared-logic';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { Colors } from '../../../../../themes/colors';
import { isIdpSourceQuestion } from '../../admin/idpQuestions';
import { QuestionException } from '../shared/questionExceptionHandling';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';

const i18nPrefix = 'routines.workflow.admin.question';

export const MediaQuestionAdminForm: RoutineQuestionAdminForm<
  MediaQuestionConfig
> = (props: RoutineQuestionAdminFormProps<MediaQuestionConfig>) => {
  const { t } = useTranslation();
  const idpEnabled = !!useWatch({ control: props.control, name: 'idpEnabled' });
  // Mirrors workflowAdminPage's own `hasPinnedIdpSource` check: `isIdpSource`
  // survives an IDP off-toggle (only enforcement stops, see idpQuestions.ts),
  // so this question is only actually locked/pinned while IDP is on too.
  const isLockedIdpSource = idpEnabled && isIdpSourceQuestion(props.config);

  return (
    <>
      {isLockedIdpSource && (
        <Text style={styles.hint}>{t(`${i18nPrefix}.idpSourceImageOnly`)}</Text>
      )}
      <QuestionException {...props} />
    </>
  );
};

const styles = StyleSheet.create({
  hint: {
    fontSize: 14,
    lineHeight: 18,
    color: Colors.grayText,
    marginBottom: 20,
  },
});
